import { createSlice } from "@reduxjs/toolkit";
import { getNotificationLogs, updateNotificationLogsStatus } from "../api/notification";
import { preprocessNotifications } from "../../shared/utils/notificationUtils";

interface NotificationState {
    loading: boolean;
    currentRequestId: string | undefined;
    notificationLogs: any;
    processedNotifications: any;
    hasUnseen: boolean;
    error: any;
}

const initialState: NotificationState = {
    loading: false,
    currentRequestId: undefined,
    notificationLogs: null,
    processedNotifications: null,
    hasUnseen: false,
    error: null,
}

export const NotificationDataSlice = createSlice({
    name: 'notificationData',
    initialState,
    reducers: {
        resetNotificationState: () => initialState,
    },
    extraReducers(builder) {
        builder
            .addCase("RESET_ALL", (state, action) => {
                return initialState;
            })
            .addCase(getNotificationLogs.pending, (state, action) => {
                state.loading = true;
                state.currentRequestId = action.meta.requestId;
            })
            .addCase(getNotificationLogs.fulfilled, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                    
                    if(action.payload.status === 200) {
                        state.notificationLogs = action.payload.data;
                        const {processedNotifications, hasUnseen} = preprocessNotifications(action.payload.data);
                        state.processedNotifications = processedNotifications;
                        state.hasUnseen = hasUnseen;
                    }
                }
            })
            .addCase(getNotificationLogs.rejected, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                    state.error = action.error;
                }
            })
            .addCase(updateNotificationLogsStatus.pending, (state, action) => {
                state.loading = true;
                state.currentRequestId = action.meta.requestId;
            })
            .addCase(updateNotificationLogsStatus.fulfilled, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                }
            })
            .addCase(updateNotificationLogsStatus.rejected, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                    state.error = action.error;
                }
            })
    }
})

export const { resetNotificationState } = NotificationDataSlice.actions;

export default NotificationDataSlice.reducer;